import { DateTime } from '@skyjs/date';
import autoRefreshAuthToken from './autoRefreshAuthToken.js';
import getTokenExpirationDate from './getTokenExpirationDate.js';
import refreshAuthToken from './refreshAuthToken.js';
import redirectToLogin from './redirectToLogin.js';
import getAuthTokenExpirationCookie from './getAuthTokenExpirationCookie.js';

export default async function startAutoRefreshAuthToken(
  authToken,
  authTokenExpirationDate,
  refreshToken,
  onAuthTokenUpdated
) {
  const authTokenExpirationCookie = getAuthTokenExpirationCookie();

  let tokenExpiration;

  if (authToken != null) {
    if (refreshToken == null) return;
    tokenExpiration = getTokenExpirationDate(authToken);
    if (tokenExpiration == null) return;
  } else if (authTokenExpirationCookie != null) {
    tokenExpiration = DateTime.fromISO(authTokenExpirationCookie);
  } else if (authTokenExpirationDate != null) {
    tokenExpiration = DateTime.fromISO(authTokenExpirationDate);
  } else {
    return;
  }

  if (DateTime.now >= tokenExpiration.subtract(30, 'second')) {
    try {
      const {
        authToken: newAuthToken,
        authTokenExpirationDate: newAuthTokenExpirationDate,
        refreshToken: newRefreshToken
      } = await refreshAuthToken();

      onAuthTokenUpdated(newAuthToken, newAuthTokenExpirationDate, newRefreshToken);
    } catch (err) {
      if (err.status === 401) {
        await redirectToLogin();
      } else {
        throw err;
      }
    }
  } else {
    await autoRefreshAuthToken(
      authToken,
      authTokenExpirationDate,
      refreshToken,
      onAuthTokenUpdated
    );
  }
}
